module.exports = __webpack_public_path__ + "img/install-shansuan.2e99b21a.jpg";